class ScrollingCards {
  constructor() {
    this.canAnimate = false;
    this.initialize = this.initialize.bind(this);
    this.initialize();
    this.xOne = 110;
    this.xTwo = window.innerWidth > 768 ? 210 : 110;
    this.scroll = 0;
    this.animate = this.animate.bind(this)
    this.animate();
    this.isMobile = window.innerWidth <= 768;
    
    window.addEventListener('resize', this.initialize.bind(this));
  }

  animate() {
    if(this.canAnimate) {
      const isTablet = window.innerWidth <= 768;
      
      const newScroll = ( this.scroll - (this.containerPos.top - (window.innerHeight * 0.4)) )
      const scrollPercent = newScroll / (window.innerHeight * 0.5);

      if(scrollPercent > 0 && scrollPercent <= 1) {
        if(isTablet) {
          this.xOne = lerp(this.xOne, 110 - scrollPercent * 110, 0.05)
        } else {
          this.xOne = lerp(this.xOne, 210 - scrollPercent * 210, 0.05)
        }
      } else if(scrollPercent > 1) {
        this.xOne = lerp(this.xOne, 0, 0.05)
      } else {
        if(isTablet) {
          this.xOne = lerp(this.xOne, 110, 0.05)
        } else {
          this.xOne = lerp(this.xOne, 210, 0.05)
        }
      }

      const secondaryThreshold = this.isMobile ? 3 : 1.5;
  
      if(scrollPercent > secondaryThreshold && scrollPercent <= secondaryThreshold + 1) {
        this.xTwo = lerp(this.xTwo, 110 - (scrollPercent - secondaryThreshold) * 110 , 0.05);
      } else if(scrollPercent > secondaryThreshold + 1) {
        this.xTwo = lerp(this.xTwo, 0, 0.05);
      } else {
        this.xTwo = lerp(this.xTwo, 110, 0.05);
      }
  
      // }
      // if(scrollPercent > 1 && scrollPercent <= 2) {
      this.cardOne.style.transform = `translateX(${this.xOne}%)`
      this.cardTwo.style.transform = `translateX(${this.xTwo}%)`
      // }
    }

    requestAnimationFrame(this.animate)
  }
  
  initialize() {
    this.container = document.querySelector('[data-scrolling-cards]');
    if(!this.container) return this.canAnimate = false;
    this.canAnimate = true;
    this.containerPos = this.container.getBoundingClientRect();
    this.cardOne = document.querySelector('[data-card-one]');
    this.cardTwo = document.querySelector('[data-card-two]');
  }

  onScroll(scroll) {
    this.scroll = scroll;
  }
}

const scrollingCards = new ScrollingCards();